import { IBilingListReducer, IOrganizationBillingListResponse } from "@/utils/types";
import { PayloadAction } from "@reduxjs/toolkit";

export const pendingOperation = (state: IBilingListReducer) => {
    state.isLoading = true;
};

export const rejectedOperation = (state: IBilingListReducer) => {
    state.isLoading = false;
};

export const getBillingHistoryListOperation = (
    state: IBilingListReducer,
    {payload}: PayloadAction<IOrganizationBillingListResponse>
) => {
    state.billingHistoryData = payload;
    state.isLoading = false;
}
